import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const jitsiDiscovered: CaseReducer<NinchatState> = (state) => state
